import { Platform } from "@/types/profile";

export const platformDisplayNames: Record<string, string> = {
  'macos': 'macOS',
  'ios': 'iOS',
  'ipados': 'iPadOS',
  'tvos': 'tvOS',
  'watchos': 'watchOS',
  'visionos': 'visionOS',
};

export const formatPlatformName = (platform: string): string => {
  return platformDisplayNames[platform.toLowerCase()] || platform;
};
